import { render } from "./DetailsSidebar.vue?vue&type=template&id=54409c74&scoped=true"
import script from "./DetailsSidebar.vue?vue&type=script&lang=js"
export * from "./DetailsSidebar.vue?vue&type=script&lang=js"

import "./DetailsSidebar.vue?vue&type=style&index=0&id=54409c74&scoped=true&lang=css"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54409c74"]])

export default __exports__